export const routeColors = [
  {
    route: '/matches',
    color: '#a7be06',
  },
  {
    route: '/match',
    color: '#a7be06',
  },
  {
    route: '/teams',
    color: '#00a3ff',
  },
  {
    route: '/clubs',
    color: '#ff118e',
  },
  {
    route: '/hand-history',
    color: '#a7be06',
  },
  {
    route: '/leaderboard',
    color: '#a7be06',
  },
  {
    route: '/replayer',
    color: '#a7be06',
  },
  {
    route: '/nf/ifmp',
    color: '#6851A2',
  },
  {
    route: '/nf',
    color: '#FF9A17',
  },
];

export const defaultColor = '#585858';
